import {endOfDay, startOfDay} from "date-fns";
import config from '../config';

export async function fetchAdminOverview(backendFetch, date) {
    const fromts = Math.round(startOfDay(date).getTime() / 1000);
    const tots = Math.round(endOfDay(date).getTime() / 1000);

    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/admin/overview?fromts=" + fromts + "&tots=" + tots)
    return await f.json()
}


export async function sendManualOverrideCommandAdmin(backendFetch, action, gridFeedInLimit, quarters) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/admin/override", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({action: action, grid_feed_in_limit: gridFeedInLimit, quarters: quarters})
    })
    return await f.json()
}

export async function sendManualOverrideClearAdmin(backendFetch) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/admin/clear", {method: "GET"})
    return await f.json()
}

export async function getAdminLog(backendFetch) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/admin/log", {method: "GET"})
    return await f.json()
}